"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _md = require("./md5");
var _md2 = _interopRequireDefault(_md);
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (o) { return typeof o === "undefined" ? "undefined" : _typeof(o); } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o === "undefined" ? "undefined" : _typeof(o); }, _typeof(o); }
/**
 * https://blog.csdn.net/qq_25234671/article/details/85322863
 * 格式化时间戳 类似PHP的date()
 * @param split
 * @param timeInMs
 * @param timeType
 * @returns {string}
 */
function getFormatDate(split, timeInMs) {
  var formatDateStr = '';
  var date = new Date();
  date.setTime(timeInMs * 1000);
  for (var i = 0; i < split.length; i++) {
    switch (split[i]) {
      case 'Y':
        formatDateStr += date.getFullYear();
        break;
      case 'm':
        formatDateStr += date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        break;
      case 'd':
        formatDateStr += date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        break;
      case 'H':
        formatDateStr += date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        break;
      case 'i':
        formatDateStr += date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        break;
      case 's':
        formatDateStr += date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        break;
      default:
        formatDateStr += split[i];
        break;
    }
  }
  // > getFormatDate('Y-m-d H:i:s',1234567891);
  // > 2009-02-14 07:31:31
  return formatDateStr;
}

/**
 * 公共默认参数
 */
function commonParams() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var date = new Date();
  var nowSec = getFormatDate('Y-m-d H:i:s', parseInt(date.valueOf() / 1000));
  var common = {};
  var obj = Object.assign(option);
  common.timestamp = obj.timestamp = nowSec;
  var signKey = option.signKey || 'yskey.key';
  var keyArr = Object.keys(obj).sort();
  var sign = '';
  for (var i in keyArr) {
    if (obj[keyArr[i]] !== '') {
      sign += keyArr[i] + "=" + obj[keyArr[i]] + "&";
    }
  }
  if (sign.trim().substr(-1) == '&') {
    sign = sign.substring(0, sign.length - 1);
  }
  sign = (sign + signKey).trim();
  common.sign = _md2.default.md5(sign);
  return common;
}
;
function deepcopy(obj) {
  var newobj = {};
  for (var arr in obj) {
    if (_typeof(obj[arr]) === 'object' && obj[arr] !== null) {
      newobj[arr] = deepcopy(obj[arr]);
    } else {
      newobj[arr] = obj[arr];
    }
  }
  return newobj;
}
exports.default = commonParams;